export default function ($translate) {
    return {
        KEYS: {
            REMOVE_SELECTED: 'REMOVE_SELECTED',
            CHANGE_ACCESS_UNTIL: 'CHANGE_ACCESS_UNTIL'
        },
        LABELS: {
            REMOVE_SELECTED: $translate.instant('planning.employee.bulkActions.remove'),
            CHANGE_ACCESS_UNTIL: $translate.instant('planning.employee.bulkActions.change access until')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/planning/employee/bulkActions/index.js